module.exports = __webpack_public_path__ + "media/icons/document238 (1)-fe2de221.png";